import React from 'react';
import logo from './logo.svg';
import UserApp from './UserApp';
import { Router } from 'react-router-dom';
import './styles/stylesheets/style.css';
import history from './router/history';
import './App.css';
// import '../src/styles/stylesheets';
// import "./styles/stylesheets/"
// src\styles\stylesheets
// import ReactGA from "react-ga4";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { GOOGLE_MEASUREMENT_ID } from './utility/constants/constants';

// ReactGA.initialize("G-JQP2VDZ77Y");
// ReactGA.send({ hitType: "pageview", page: window.location.pathname });


const firebaseConfig = {
  apiKey: "AIzaSyA8kGwNTV0AXdqLVcLIRhyaaCJvjiBYaO8",
  authDomain: "pegasus-303706.firebaseapp.com",
  projectId: "pegasus-303706",
  storageBucket: "pegasus-303706.appspot.com",
  messagingSenderId: "552971432299",
  appId: "1:552971432299:web:995dbfd5a5962a748e1c2e",
  measurementId: "G-S534CDS2P7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
class App extends React.Component {
  render() {
    return (
      <Router history={history}>
        <UserApp />
      </Router>
    );
  }

}
export default App;
